import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var LineChartDown01 = function LineChartDown01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M21 21H4.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C3 20.2401 3 19.9601 3 19.4V3m17 12-3.9189-4.1827c-.1485-.1585-.2227-.2377-.3123-.2787a.5.5 0 0 0-.2528-.0433c-.0981.0089-.1945.0589-.3873.159l-3.2574 1.6914c-.1928.1001-.2892.1501-.3873.159a.5.5 0 0 1-.2528-.0433c-.0896-.041-.1638-.1202-.3123-.2787L7 8"
    })
  }));
};
export default LineChartDown01;